// PB-1853: default the invest-page Reference Rate from the product's
// per-stablecoin rates (PS 1-day USD product carries 0.996 for both).
// Returns the 6-decimal string format the field uses; '1.000000' whenever
// no product rate applies, matching the pre-PB-1853 default.
export function defaultReferenceRate(product, investCurrency) {
  if (!product || (product.product_ccy || '').toUpperCase() !== 'USD') {
    return '1.000000';
  }
  const ccy = (investCurrency || '').toUpperCase();
  const raw =
    ccy === 'USDT'
      ? product.usdtReferenceRate
      : ccy === 'USDC'
        ? product.usdcReferenceRate
        : null;
  const rate = Number(raw);
  if (raw == null || !Number.isFinite(rate) || rate <= 0) {
    return '1.000000';
  }
  return rate.toFixed(6);
}
